import { useForm } from "react-hook-form";
import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Grid, TextField } from "@material-ui/core";
import { onDrop } from '../../../store/constructs/clusterlets/actions';
import { getClusterlets } from "../../../store/constructs/clusterlets/selectors";
import { basic, validationMessages } from '../../../config/validations';
import { checkNameExist } from '../bluePrintComponents/SystemModel/helpers';
import CreateCancel from "../../atoms/buttons/CreateCancel";
import { findRelativePosition } from '../../../services/reactFlowService';

export const CreateSensorForm = (props) => {

    const { onClose, onCompletion, clusterletDetails } = props;
    const { register, handleSubmit, formState: { errors } } = useForm();

    const dispatch = useDispatch();
    const clusterlets = useSelector(getClusterlets);
    const [saveText, setsaveText] = useState("Create")

    const messages = {
        ...validationMessages,
        validate: 'Clusterlet with the given name exists'
    }

    const nameExist = (name) => {
        const status = checkNameExist(name, clusterlets)
        return status === true ? false : true
    }

    const onSave = (data) => {
        setsaveText("Saving....")
        clusterletDetails.name = data.name;
        clusterletDetails.attributes.desc = data.description;

        const position = findRelativePosition(clusterletDetails.position, clusterletDetails.type);
        clusterletDetails.position = position;
        
        dispatch(onDrop(clusterletDetails));
        onCompletion();
    }

    return (
        <Grid container direction={"row"} spacing={3}>
            <Grid item xs={12}>
                <TextField
                    name="name"
                    autoFocus
                    fullWidth
                    type={"text"}
                    required
                    label={"Name"}
                    placeholder={""}
                    variant="outlined"
                    inputRef={register({ ...basic, validate: nameExist })}
                    error={errors?.name ? true : false}
                    helperText={errors?.name ? messages[errors?.name?.type] : ''}
                />
            </Grid>
            <Grid item xs={12}>
                <TextField
                    name="description"
                    type={"text"}
                    fullWidth
                    rows={4}
                    label={"Description"}
                    placeholder={""}
                    variant="outlined"
                    multiline={true}
                    inputRef={register({ required: false, })}
                />
            </Grid>

            <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end", marginBottom: 20 }}>
                <CreateCancel onCreate={handleSubmit(onSave)} onCancel={onClose} />
            </Grid>
        </Grid>
    );

}